import axios from "axios";
import { apiForAuthMS } from "../config";

export const axiosForAuth = axios.create({
 baseURL: apiForAuthMS,
 withCredentials: true,
});
